/** Notify mounted live passport readers after a persisted target or preference change. */
export const PASSPORT_REFRESH_EVENT = "sill:passport-refresh";

export function invalidateLivePassport(): void {
  if (typeof window !== "undefined")
    window.dispatchEvent(new Event(PASSPORT_REFRESH_EVENT));
}
